export enum AppRoutes {
    Assigned = '/assigned',
    ChoosePlan = '/choose-plan',
    CreateLog = '/create-log',
    CreateProject = '/create-project',
    Dashboard = '/dashboard',
    EditLog = '/edit-log',
    IntegrationInstructions = '/integration-instructions',
    ForgotPassword = '/account-recovery',
    Login = '/',
    LogOverview = '/log-overview',
    Notifications = '/notifications',
    Payments = '/payments',
    Projects = '/projects',
    Register = '/register',
    Settings = '/settings',
    Starred = '/starred',
    DevPanel = '/devpanel',
    TermsOfUse = '/terms-of-use',
    ReportProblem = '/report-problem',
    UserAccount = '/user-settings',
    ResetPassword = '/reset-password',
}


export function assignedLink(flatId?: string) {
    return AppRoutes.Assigned + (flatId ? '/' + flatId : '/');
}

export function choosePlanLink(): string {
    return AppRoutes.ChoosePlan;
}

export function createLogLink(projectId: string) {
    return AppRoutes.CreateLog + '/' + projectId;
}

export function editLogLink(logId: string) {
    return AppRoutes.EditLog + '/' + logId;
}

export function integrationInstructionsLink(logId: string) {
    return AppRoutes.IntegrationInstructions + '/' + logId;
}

export function logOverviewLink(logId: string, flatId?: string) {
    return AppRoutes.LogOverview + '/' + logId + (flatId ? '/' + flatId : '/');
}

export function paymentsLink() {
    return AppRoutes.Payments;
}

export function projectDashboardLink(projectId: string) {
    return AppRoutes.Dashboard + '/' + projectId;
}

export function projectsLink() {
    return AppRoutes.Projects;
}

export function settingsLink(projectId: string) {
    return AppRoutes.Settings + '/' + projectId;
}

export function starredLink(flatId?: string) {
    return AppRoutes.Starred + (flatId ? '/' + flatId : '/');
}
